/**
 * Nonce for dynamically loaded module scripts (must match Content-Security-Policy script-src).
 */
export default function getCspNonce() {
  if (typeof document === 'undefined') {
    return '';
  }

  const scriptWithNonce = document.querySelector('script[nonce]');
  if (scriptWithNonce && scriptWithNonce.nonce) {
    return scriptWithNonce.nonce;
  }

  const meta = document.querySelector('meta[name="csp-nonce"]');
  if (meta) {
    return meta.getAttribute('content') || '';
  }

  return '';
}
